import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import dayjs from "dayjs";
import html2pdf from "html2pdf.js";
import commonLabels from "../../../common/labels/common_en.json";
import label from "../../labels/postExaminationProcessObjective_en.json";
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
  getSubjectlistByExamId,
  getDuplicateListByExamIdSubId,
  updateDuplicateRollNoData,
  getAllApprovalDuplicateRollNoListPagination,
  getAbsenteeListByExamIdSubId,
  updatAbsenteeListData,
  getAllApprovalAbsenteeListPagination,
  objetiveStatusLockUnlock,
  getObjectiveStatus,
  getObjectiveStatusflag,
} from "../../actions/postExaminationProcessObjectiveActions";
import TablePagination from "../../../common/components/TablePagination";
import DuplicateApprovalEntity from "./DuplicateApprovalEntity";
import { Button, Space, Tree } from "antd";
import FileViewModal from "../../../common/components/FileViewModal";
import AbsenteeApprovalEntity from "./AbsenteeApprovalEntity";
import {
  getYearList,
  getAdvertisementlistByYear,
} from "../../../common/actions/commonActions";
import { SET_OBJECTIVE_STATUS_DATA_FLAG, SET_PROCESS_LOCK_STATE } from "../../../common/constants/ActionTypes";
import { toastr } from "react-redux-toastr";

const AbsentList = () => {
  let unapprovalEntityHeader = [
    "No.",
    "Action",
    "Status",
    "Updated On",
    "Exam Name",
    "Subject Name",
    "Entity Type",
    "Approval Type",
    "Approver",
    "Comments By Approver",
    "Action",
  ];
  const pdfRef = useRef(null);

  const { register, handleSubmit, errors, reset } = useForm({
    mode: "onChange",
  });

  let {
    examList,
    advertisementList,
    subjectList,
    absenteeList,
    unapprovalAbsenteeList,
    unapprovalAbsenteeListCounter,
    objectiveStatusData,
    objectiveStatusDataFlag,
  } = useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);
  let { yearList, allYearList, processLockState } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  let rowPerPage = 10;
  let tableCounter_unapproval = unapprovalAbsenteeListCounter + 1;

  const [stepName, setName] = useState("absenteeList");
  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [printFlag, setPrintFlag] = useState(true);
  const [absentDtos, setAbsentDtos] = useState([]);
  const [viewImageModal, setViewImageModal] = useState(false);
  const [selectedVenue, setSelectedVenue] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editedValues, setEditedValues] = useState([]);
  const [addYear, setAddYear] = useState("");
  const [selectedSubjectType, setSelectedSubjectType] = useState("");
  const labels = Array.from({ length: 7 }, (_, index) => `Booklet / Sheet No`);
  const session = JSON.parse(sessionStorage.getItem("session"));
  let [selectedApprovalEntity, setSelectedApprovalEntity] = useState("");
  let [selectedImageContent, setSelectedImageContent] = useState("");
  let [approvalEntityModal, setApprovalEntityModal] = useState(false);
  let [listCurrentPage, setListCurrentPage] = useState(0);
  const [flagArray, setFlagArray] = useState([]);
  const [localLockState, setLocalLockState] = useState({
    absent: false,
    duplicate: false
  });
  // const [confirmClicked, setConfirmClicked] = useState(false);
  const dispatch = useDispatch();

  const isExamSelected = !!selectedExam;

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getYearList());
    onCancelButton();
    dispatch({
      payload: [],
      type: SET_OBJECTIVE_STATUS_DATA_FLAG,
    });

    flagArray.length = 0;
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    return () => {
      // This runs on component unmount
      dispatch({
        payload: [],
        type: SET_OBJECTIVE_STATUS_DATA_FLAG,
      });
    };
  }, []);
  useEffect(() => {
    if (stepName === "absentListApproval")
      dispatch(getAllApprovalAbsenteeListPagination(0, rowPerPage));
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepName]);

  useEffect(() => {
    if (absenteeList.subjectType === "objective" && absenteeList.absentee) {
      setAbsentDtos(absenteeList.absentee);
      setEditedValues(absenteeList);
    } else if (
      absenteeList.subjectType === "descriptive" &&
      absenteeList.descriptiveAbsentee
    ) {
      setAbsentDtos(absenteeList.descriptiveAbsentee);
      setEditedValues(absenteeList);
    }
  }, [absenteeList.absentee, absenteeList.descriptiveAbsentee]);

  useEffect(() => {
    setPrintFlag(absentDtos?.length === 0);
  }, [absentDtos?.length, setPrintFlag]);

  useEffect(() => {
    setFlagArray([]);
    if (objectiveStatusDataFlag && objectiveStatusDataFlag.length > 0) {
      const flagValues = objectiveStatusDataFlag.map((item) => item.flag);
      const flagArrayBeforeInterviewCriteria = [];

      for (let i = 0; i < flagValues.length; i++) {
        if (flagValues[i] === "Absentee") {
          setFlagArray(flagArrayBeforeInterviewCriteria);
          break;
        } else {
          flagArrayBeforeInterviewCriteria.push(objectiveStatusDataFlag[i]);
        }
      }
      if (
        flagArrayBeforeInterviewCriteria.some(
          (item) => item.flagStatus === false
        )
      ) {
        toastr.warning(label.UPLOAD_CSV_MESSAGE);
      }
    }
  }, [objectiveStatusDataFlag]);

  const onAdvertisementChange = (ele) => {
    setSelectedAdvertNo(ele);
    setSelectedExam("");
    setFlagArray([]);
    setSelectedSubject("");
    setSaveButtonFlag(true);
    setConfirmClicked(false);
    setEditMode(false);
    setPrintFlag(true);
    examList.length = subjectList.length = absentDtos.length = 0;
    ele && dispatch(getExamslistByAdvertisementId(ele));
    setReloadItem(!reloadItem);
  };

  const onSelectYear = (ele) => {
    if (ele == "") {
      onCancelButton();
    } else {
      let selectedValue = ele;
      setAddYear(selectedValue);
      advertisementList.length = 0;
      selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
      if (allYearList) {
        allYearList.length = 0;
      }
      if (examList) {
        examList.length = 0;
      }
      if (subjectList) {
        subjectList.length = 0;
      }
      if (absentDtos) {
        absentDtos.length = 0;
      }
      setEditMode(false);
      setSaveButtonFlag(true);
      setFlagArray([]);
      setReloadItem(!reloadItem);
    }
  };

  const onExamChange = (ele) => {
    Promise.resolve()
      .then(() => {
        setSelectedExam(ele);
        setSelectedSubject("");
        setSaveButtonFlag(true);
        setConfirmClicked(false);
        setPrintFlag(true);
        setEditMode(false);
        dispatch({
          type: SET_PROCESS_LOCK_STATE,
          payload: {
            absent: false,
            duplicate: false,
            outOfRange: false,
            versionMismatch: false,
            result: false
          }
        });

        subjectList.length = absentDtos.length = 0;

        if (ele) {
          return dispatch(getSubjectlistByExamId(ele));
        }
        return Promise.resolve();
      })
      .then(() => {
        if (ele) {
          return dispatch(getObjectiveStatusflag(ele, setSaveButtonFlag));
        }
        return Promise.resolve();
      })
      .then(() => {
        if (ele) {
          return dispatch(getObjectiveStatus(ele));
        }
        return Promise.resolve();
      })
      .then(() => {
        setReloadItem((prev) => !prev);
      })
      .catch((error) => {
        console.error("Error during onExamChange:", error);
      });
  };
  // useEffect(() => {
  //   if (objectiveStatusData) {
  //     setLocalLockState(prev => ({
  //       ...prev,
  //       absent: objectiveStatusData.flgAbsentLocked || false
  //     }));
  //   }
  // }, [objectiveStatusData]);

  const onSubjectChange = (ele) => {
    setSelectedSubject(ele);
    setSaveButtonFlag(false);
    setConfirmClicked(false);

    ele !== "" && setPrintFlag(true);
    setEditMode(false);

    absentDtos.length = 0;

    if (ele !== "") {
      dispatch(getObjectiveStatusflag(selectedExam, setSaveButtonFlag, ele)); // <-- NEW
      dispatch(getAbsenteeListByExamIdSubId(selectedExam, ele));
    }

    setReloadItem(!reloadItem);
  };
  const onCancelButton = () => {
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSelectedSubject("");
    setAddYear("");
    setFlagArray([]);
    setSaveButtonFlag(true);
    setConfirmClicked(false);
    setPrintFlag(true);
    setReloadItem(!reloadItem);
    setEditMode(false);
    absentDtos.length =
      allYearList.length =
      examList.length =
      subjectList.length =
      0;
    if (absenteeList.subjectType === "objective") {
      if (absenteeList.absentee && absenteeList.absentee.length > 0) {
        absenteeList.absentee.length = 0;
      }
    } else if (absenteeList.subjectType === "descriptive") {
      if (
        absenteeList.descriptiveAbsentee &&
        absenteeList.descriptiveAbsentee.length > 0
      ) {
        absenteeList.descriptiveAbsentee.length = 0;
      }
    }
  };

  const handleReset = () => {
    // reset();
  };
  const handleLockUnlock = (lock) => {
    selectedExam &&
      dispatch(
        objetiveStatusLockUnlock(
          selectedExam,
          "absent",
          lock,
          selectedSubject,
          handleReset
        )
      );
    // reset();
    // onCancelButton();
  };

  const onSubmit = () => {
    dispatch(
      updatAbsenteeListData(selectedExam, selectedSubject, editedValues)
    );
    onCancelButton();
    // dispatch(getDuplicateListByExamIdSubId(
    //     selectedExam,
    //     selectedSubject
    // ));
    // setReloadItem(!reloadItem);
  };

  const handleEditButtonClick = () => {
    setEditMode(true);
  };

  const genPdf = () => {
    let headerDiv =
      '<div class="row d-flex flex-column align-items-center"><h5 class="bold-label">' +
      label.MPSC +
      "</h5><h5>" +
      absenteeList.examName +
      "</h5><h5>" +
      absenteeList.subjectName +
      " " +
      (absenteeList.subjectType === "objective"
        ? "(Objective)"
        : absenteeList.subjectType === "descriptive"
          ? "(Descriptive)"
          : "") +
      "</h5></div>";

    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: "AbsenteeList.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");

          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, textX, textY);

          const ad = absenteeList.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save("AbsenteeList.pdf");
      });
  };

  const downloadPdf = () => {
    const content = pdfRef.current;
    const buttonToHide = content.querySelector(".button-to-hide");
    if (buttonToHide) {
      buttonToHide.style.display = "none";
    }
    genPdf();
    if (buttonToHide) {
      buttonToHide.style.display = "block";
    }
    setReloadItem(!reloadItem);
  };

  const handleViewFile = (venueName) => {
    setSelectedVenue(venueName);
    setViewImageModal(true);
  };

  const handleRollNoEdit = (ind1, ind2, data, value) => {
    let currentValues = editedValues;
    currentValues.absentee[ind1].rollNos[ind2].rollNo = value;
    setEditedValues(currentValues);
  };
  const handleApprovalUser = (ele) => {
    setSelectedApprovalEntity(ele);
    setApprovalEntityModal(true);
  };

  const RenderList = ({ list, handleViewFile, editMode, handleRollNoEdit }) => {
    return (
      <>
        {list.map((ele, ind) => (
          <div key={ind} className="mb-4">

            {/* Header Section */}
            <div className="headerSection"
            >
              <div>
                <strong className="centerName">
                  CENTRE : {ele.centerName}
                </strong>
                <br />
                <strong>ABSENT</strong>
              </div>

              <span className="button-to-hide">
                <Button
                  type="primary"
                  onClick={() => handleViewFile(ele.venueId)}
                >
                  View Attendance Sheet
                </Button>
              </span>
            </div>

            {/* Border Line */}
            <div className="font-11 mt-2 border-top-strong"></div>

            {/* Table Section */}
            <ul className="table-font-12 border-0 absent-table p-0">
              {ele?.rollNos?.length > 0 && (
                <li className="p-0 m-1 list-unstyled">
                  <table className="table text-center mb-0 duplicate-table">
                    <thead>
                      <tr>
                        <th>Roll No</th>
                      </tr>
                    </thead>

                    <tbody>
                      {ele.rollNos.map((data, index) => (
                        <tr
                          key={index}
                          onClick={() => !editMode && handleViewFile(ele.venueId)}
                          style={{
                            cursor: editMode ? "default" : "pointer"
                          }}
                        >
                          <td>
                            {editMode ? (
                              <input
                                type="text"
                                className="form-control"
                                defaultValue={data.rollNo}
                                onChange={(e) =>
                                  handleRollNoEdit(
                                    ind,
                                    index,
                                    data,
                                    e.target.value
                                  )
                                }
                              />
                            ) : (
                              data.rollNo
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </li>
              )}
            </ul>

            {/* Total Count */}
            <div
              className="totalAttendee "
            >
              Total : {ele.rollNos.length}
            </div>
          </div>
        ))}
      </>
    );
  };

  return (
    <div className="commonContentArea">
      <h5 className="labelMargin"> {label.AbsentList} </h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" key="0">
            <a
              href="#"
              className={
                stepName === "absentListApproval"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="absentListApproval"
              id="absentListApproval-tab"
              onClick={() => setName("absentListApproval")}
              data-toggle="tab"
              role="tab"
              aria-controls="absentListApproval"
              aria-selected="false"
            >
              <span>{label.APPROVAL}</span>
            </a>
          </li>
          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "absenteeList"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="absenteeList"
              id="absenteeList-tab"
              onClick={() => setName("absenteeList")}
              data-toggle="tab"
              role="tab"
              aria-controls="absenteeList"
              aria-selected="false"
            >
              <span>{label.AbsentList}</span>
            </a>
          </li>
        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "absentListApproval"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="absentListApproval"
            role="tabpanel"
            aria-labelledby="absentListApproval-tab"
          >
            {unapprovalAbsenteeList &&
              unapprovalAbsenteeList.entityApprovalDtoList &&
              unapprovalAbsenteeList.entityApprovalDtoList.length > 0 ? (
              <>
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      {unapprovalEntityHeader &&
                        unapprovalEntityHeader.map((itm, ind) => (
                          <th
                            key={ind}
                            className={`${itm === "No." || itm === "Action"
                              ? "text-center"
                              : ""
                              }`}
                          >
                            {itm}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {unapprovalAbsenteeList &&
                      unapprovalAbsenteeList.entityApprovalDtoList &&
                      unapprovalAbsenteeList.entityApprovalDtoList.length > 0 &&
                      unapprovalAbsenteeList.entityApprovalDtoList.map(
                        (ele, index) => {
                          return (
                            <tr key={index}>
                              <td className="w-5 text-center">
                                {tableCounter_unapproval++}
                              </td>
                              <td className=" word-break">
                                {ele.entityApprovalAction.actionLabel}
                              </td>
                              <td className=" width-5">
                                {ele.entityApprovalAction.level == 1
                                  ? label.APPROVAL_LEVEL_1_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 2
                                  ? label.APPROVAL_LEVEL_2_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 3
                                  ? label.APPROVAL_LEVEL_3_PENDING
                                  : ""}
                              </td>
                              <td className=" word-break width-10">
                                {ele.entityApprovalAction.updatedAt
                                  ? dayjs(
                                    ele.entityApprovalAction.updatedAt
                                  ).format("DD/MM/YYYY h:mm A")
                                  : ""}
                              </td>
                              <td className="w-10 word-break  width-20">
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.examName &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.examName}{" "}
                              </td>
                              <td className="w-10 word-break width-12">
                                {ele.entityApprovalAction.entityApprovalDto
                                  .detail &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.subjectName &&
                                  ele.entityApprovalAction.entityApprovalDto
                                    .detail.subjectName}{" "}
                              </td>
                              <td>
                                {ele.entityApprovalAction.entityApprovalDto.entityMaster.name.replace(
                                  "_",
                                  " "
                                )}
                              </td>

                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalTypeLabel
                                }
                              </td>
                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalByUser.firstName
                                }{" "}
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalByUser.lastName
                                }
                              </td>

                              <td className=" word-break width-10">
                                {ele.entityApprovalAction.comments}
                              </td>
                              <td className="text-center word-break width-15">
                                {(session.roleName == "superadmin" ||
                                  session.roleName == "desk officer") && (
                                    <button
                                      type="button"
                                      className="mx-auto btn btn-outline-primary btn-sm custom-button"
                                      onClick={() => {
                                        handleApprovalUser(ele);
                                      }}
                                    >
                                      {label.REVIEW}
                                    </button>
                                  )}
                              </td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
                <TablePagination
                  paginationFor="un_answerkey_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  totalCount={unapprovalAbsenteeList.totalNoOfRecords}
                />
              </>
            ) : (
              <div className="text-center">
                <font className="text-danger">
                  {commonLabels.NO_DATA_FOUND}
                </font>
              </div>
            )}
          </div>
          <div
            className={
              stepName === "absenteeList"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="absenteeList"
            role="tabpanel"
            aria-labelledby="absenteeList-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group ">
                    <div className="row">
                      <div className="form-group col-md-2">
                        <label className="float-left">
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedYear"
                          value={addYear}
                          // ref={register({ required: true })}
                          onChange={(e) => {
                            onSelectYear(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {yearList &&
                            yearList.length > 0 &&
                            yearList.map((element, index) => (
                              <option>{element}</option>
                              // <option key={index} value={element.id}>
                              //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                              // </option>
                            ))}
                        </select>
                        {_.get("selectedYear.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-4">
                        <label className="float-left">
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo"
                          // value={selectedAdvertNo}
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {allYearList &&
                            allYearList.length > 0 &&
                            allYearList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedAdvertiseNo.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>

                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam"
                          //  value={selectedExam}
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onExamChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted == false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedExam.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>

                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectSubject}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedSubject"
                          // value={selectedSubject}
                          ref={register({ required: true })}
                          // onChange={(e) => {
                          //   onSubjectChange(e.target.value);
                          // }}
                          onChange={(e) => {
                            const selected = subjectList.find(
                              (item) => item.id === Number(e.target.value)
                            );
                            setSelectedSubjectType(selected?.type || "");
                            onSubjectChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {subjectList &&
                            subjectList.length > 0 &&
                            subjectList
                              // .filter(
                              //   (element) =>
                              //     element.isDeleted == false &&
                              //     element.isActive === true
                              // )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}({element.type?.toUpperCase()})
                                </option>
                              ))}
                        </select>
                        {_.get("selectedSubject.type", errors) ===
                          "required" && (
                            <p className="errorText float-left">
                              {commonLabels.MANDATORY_FIELD_MESSAGE}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="row pl-3 pr-3">
                      {/* {flagArray &&
                        flagArray.length > 0 &&
                        flagArray.map((ele, index) => (
                          <div className="d-flex p-2" key={index}>
                            <input
                              type="checkbox"
                              disabled
                              checked={ele.flagStatus === true && true}
                              className="form-control"
                            />
                            <label className="ml-1">{ele.flag}</label>
                          </div>
                        ))} */}
                      {flagArray &&
                        flagArray
                          .filter((ele) => {
                            if (
                              selectedSubjectType === "descriptive" &&
                              ele.flag === "Marks Criteria"
                            ) {
                              return ele.flagStatus === true;
                            }
                            return true;
                          })
                          .map((ele, index) => (
                            <div className="d-flex p-2" key={index}>
                              <input
                                type="checkbox"
                                disabled
                                checked={ele.flagStatus}
                                className="form-control"
                              />
                              <label className="ml-1">{ele.flag}</label>
                            </div>
                          ))}
                    </div>

                    <div className="row">
                      <div className="form-group col-md-8">
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {commonLabels.BUTTON_CANCEL}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary mr-2"
                          disabled={saveButtonFlag || editMode || printFlag}
                          onClick={handleEditButtonClick}
                        >
                          {commonLabels.BUTTON_EDIT}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary mr-2"
                          disabled={
                            saveButtonFlag ||
                            editedValues.length === 0 ||
                            (absenteeList.absentee &&
                              absenteeList?.absentee?.length == 0)
                          }
                          onClick={handleSubmit((e) => {
                            onSubmit(e);
                            setConfirmClicked(true);
                          })}
                        >
                          {commonLabels.BUTTON_CONFIRM}
                        </button>

                        {(session.roleName == "superadmin" ||
                          session.roleName == "secretary") && (
                            <button
                              type="button"
                              className="btn btn-primary mr-2"
                              // disabled={printFlag || editMode}
                              disabled={
                                (absenteeList.isStatusLocked !== null &&
                                  absenteeList.isStatusLocked !== true &&
                                  absenteeList.isStatusLocked !== false) ||
                                editMode ||
                                absenteeList?.absentee?.length === 0
                              }
                              onClick={() => {
                                downloadPdf();
                              }}
                            >
                              {commonLabels.BUTTON_PRINT}
                            </button>
                          )}
                        {(session.roleName == "superadmin" ||
                          session.roleName == "secretary") && (
                            <button
                              type="button"
                              className={`btn mr-2 ${processLockState.absent
                                ? "btn-lock-green"
                                : "btn-unlock-red"
                                } `}
                              style={{
                                borderRadius: "0.60rem",
                              }}
                              disabled={!selectedExam || !selectedSubject || editMode}
                              onClick={() => {
                                const newState = !processLockState.absent;

                                dispatch({
                                  type: SET_PROCESS_LOCK_STATE,
                                  payload: {
                                    ...processLockState,
                                    absent: newState,
                                  },
                                });

                                handleLockUnlock(newState);
                              }}
                            >
                              {processLockState.absent ? "Unlock" : "Lock"}
                            </button>
                          )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {absenteeList &&
              absenteeList.subjectType === "objective" &&
              absenteeList.absentee?.length > 0 && (
                <>
                  <div>
                    <label className="font-weight-bold text-dark ml-5 mb-2">
                      {absenteeList.subjectType === "objective" && "Objective"}
                    </label>
                  </div>
                  <div
                    ref={pdfRef}
                    className="answerKeyTable"
                    id="absenteeList"
                  >
                    <div className="row">
                      <div className="col-md-12">
                        <RenderList
                          list={absenteeList.absentee}
                          handleViewFile={handleViewFile}
                          editMode={editMode}
                          handleRollNoEdit={handleRollNoEdit}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

            {absenteeList &&
              absenteeList.subjectType === "descriptive" &&
              absenteeList.descriptiveAbsentee?.length > 0 && (
                <>
                  <div>
                    <label className="font-weight-bold text-dark ml-5 mb-2">
                      {absenteeList.subjectType === "descriptive" &&
                        "Descriptive"}
                    </label>
                  </div>

                  <div
                    ref={pdfRef}
                    className="answerKeyTable"
                    id="absenteeList"
                  >
                    <div className="row ">
                      <div className="col-md-12">
                        <RenderList
                          list={absenteeList.descriptiveAbsentee}
                          handleViewFile={handleViewFile}
                          editMode={editMode}
                          handleRollNoEdit={handleRollNoEdit}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
          </div>
          {approvalEntityModal && (
            <AbsenteeApprovalEntity
              showModal={approvalEntityModal}
              setShowModal={setApprovalEntityModal}
              setSelectedApprovalEntity={selectedApprovalEntity}
            />
          )}
          {viewImageModal && (
            <FileViewModal
              showModal={viewImageModal}
              setShowModal={setViewImageModal}
              setSelectedApprovalEntity={selectedVenue}
              selectedSubject={selectedSubject}
              selectedExam={selectedExam}
              venueName={selectedVenue}
              fileType="pdf"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AbsentList;
